import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getLedFamilies } from '../../../user/selectors';

import presenter from './presenter';

const mapStateToProps = createStructuredSelector({
  ledFamilies: getLedFamilies,
});

export default connect(
  mapStateToProps,
)(presenter);
